import { useEffect } from 'react';
import { useReadableEventRefresher } from '@zdr-tools/zdr-react';
import { useSignInFacade } from './useSignInFacade.js';
/**
 * Reads whether the login site can offer "Continue with Google", and asks the sign-in facade to prepare Google (fetch
 * the client id, load Google's script) the first time a component needs it. Re-renders the caller whenever the
 * availability changes.
 *
 * Takes no parameters: there is a single sign-in per page, so the availability always exists. Preparing runs at most
 * once per page: the facade starts it only from `UNKNOWN`, so a StrictMode double effect or a second component using
 * this hook does not repeat it. The ID tokens Google hands back go to the facade directly; this hook starts nothing
 * else.
 *
 * @returns `UNKNOWN` before preparing starts, `PREPARING` while the client id and Google's script load, `AVAILABLE`
 * once Google's button may be rendered, or `UNAVAILABLE` when Google could not be prepared (the email code still
 * works). There is no "not found" case.
 * @throws Error `useSignInFacade must be used within SignInContextProvider` when called outside a
 * `SignInContextProvider`.
 */
export function useGoogleSignIn() {
    const facade = useSignInFacade();
    const [[availability]] = useReadableEventRefresher(facade.getGoogleAvailability().status);
    useEffect(() => {
        void facade.ensureGoogleSignIn();
    }, [facade]);
    return availability;
}
//# sourceMappingURL=useGoogleSignIn.js.map